import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2c-8.072 -.49 -14.51 -6.928 -15 -15a2 2 0 0 1 2 -2","key":"svg-0"}],["path",{"d":"M17 3v5","key":"svg-1"}],["path",{"d":"M21 3v5","key":"svg-2"}]]

const IconPhonePause = createReactComponent('outline', 'phone-pause', 'PhonePause', __iconNode);

export default IconPhonePause;